"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Hue = void 0;

var _jsxRuntime = require("react/jsx-runtime");

var _react = require("react");

var _utils = require("../../utils");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Hue = function Hue(_ref) {
  var width = _ref.width,
      color = _ref.color,
      onChange = _ref.onChange;
  var hueRef = (0, _react.useRef)(null);
  var position = (0, _react.useMemo)(function () {
    var x = (0, _utils.getCoordinatesByHue)(color.hsb.h, width);
    return x;
  }, [color.hsb.h, width]);

  var moveCursor = function moveCursor(x, shiftX) {
    var _moveAt = (0, _utils.moveAt)({
      value: x,
      shift: shiftX,
      min: 0,
      max: width
    }),
        _moveAt2 = _slicedToArray(_moveAt, 1),
        newX = _moveAt2[0];

    var newHue = (0, _utils.getHueByCoordinates)(newX, width);
    onChange((0, _utils.toColor)("hsb", _objectSpread(_objectSpread({}, color.hsb), {}, {
      h: newHue
    })));
  };

  var onMouseDown = function onMouseDown(e) {
    if (hueRef.current) {
      var _document$getSelectio;

      if (e.button !== 0) return;
      var hue = hueRef.current;
      (_document$getSelectio = document.getSelection()) === null || _document$getSelectio === void 0 ? void 0 : _document$getSelectio.empty();

      var _hue$getBoundingClien = hue.getBoundingClientRect(),
          shiftX = _hue$getBoundingClien.left;

      moveCursor(e.clientX, shiftX);

      var onMouseMove = function onMouseMove(e) {
        moveCursor(e.clientX, shiftX);
      };

      var onMouseUp = function onMouseUp() {
        document.removeEventListener("mousemove", onMouseMove, false);
        document.removeEventListener("mouseup", onMouseUp, false);
      };

      document.addEventListener("mousemove", onMouseMove, false);
      document.addEventListener("mouseup", onMouseUp, false);
    }
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    ref: hueRef,
    className: "rcp-hue",
    onMouseDown: onMouseDown,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "rcp-hue-cursor",
      style: {
        left: position,
        backgroundColor: "hsl(".concat(color.hsb.h, ", 100%, 50%)")
      }
    })
  });
};

exports.Hue = Hue;